import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=605da8c2&scoped=true&"
import script from "./AlertComponent.vue?vue&type=script&lang=js&"
export * from "./AlertComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=605da8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605da8c2",
  null
  
)

component.options.__file = "AlertComponent.vue"
export default component.exports